
import React from 'react';
import { InfoItem } from '../types';

interface InfoCardProps {
  item: InfoItem;
}

const InfoCard: React.FC<InfoCardProps> = ({ item }) => {
  const { Icon } = item;
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      {Icon && (
        <div className="flex items-center mb-3">
          <Icon className="h-8 w-8 text-green-500 mr-3" />
          <h3 className="text-xl font-semibold text-slate-700">{item.title}</h3>
        </div>
      )}
      {!Icon && <h3 className="text-xl font-semibold text-slate-700 mb-3">{item.title}</h3>}
      {typeof item.content === 'string' ? (
        <p className="text-slate-600 text-sm">{item.content}</p>
      ) : (
        <div className="text-slate-600 text-sm">{item.content}</div>
      )}
    </div>
  );
};

export default InfoCard;
